
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","stroke":"#6C7684","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.498 8.996v3.001M22.502 8.996v3.001M15.999 27.003h-4.002a3.001 3.001 0 01-3-3.001V13.497a3.001 3.001 0 013-3h12.005a3.001 3.001 0 013.002 3v2.501M22.395 20.982v1.76l1.382.842","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22.502 27.004A4.502 4.502 0 0118 22.502 4.57 4.57 0 0122.506 18a4.502 4.502 0 11-.004 9.004","stroke-width":"1.5"}})])
          )
        }
      }
    